/**
 * Sidebar panel that lists generated reports for the selected feature and
 * lets the user open the report-export modal. Extracted from MPV's
 * `renderReports` helper. Mounts in the right-side TabbedSidebar's Reports
 * tab; pre-fills the export filter state from notes-side "save as report"
 * actions.
 */

import * as I from 'immutable';
import React from 'react';

import Reports, {ReportExportState} from 'app/components/NotesReports/ReportsView';
import {ApiFeature} from 'app/modules/Remote/Feature';
import {ApiFeatureCollection, GeometryOverlaySetting} from 'app/modules/Remote/FeatureCollection';
import {ApiOrganization} from 'app/modules/Remote/Organization';
import {NotesState} from 'app/stores/NotesStore';
import * as noteUtils from 'app/utils/noteUtils';

interface Props {
  projectId: string;
  feature: I.ImmutableOf<ApiFeature>;
  featureCollection: I.ImmutableOf<ApiFeatureCollection>;
  propertyParts: I.ImmutableOf<ApiFeature[]>;
  overlayFeatureCollections: I.ImmutableOf<ApiFeatureCollection[]>;
  overlaySettings: GeometryOverlaySetting[];
  isMultiLocationProperty: boolean;
  organization: I.ImmutableOf<ApiOrganization>;
  notesState: NotesState;
  notesFilterState: noteUtils.NotesFilterState;
  pendingNewReportExportState: ReportExportState | null;
  setNotesFilterState: (state?: noteUtils.NotesFilterState) => void;
  setReportExportModalState: (state: ReportExportState | null) => void;
  openReportExportModal: (state: ReportExportState) => void;
}

export default function ReportsPanel({
  projectId,
  feature,
  featureCollection,
  propertyParts,
  overlayFeatureCollections,
  overlaySettings,
  isMultiLocationProperty,
  organization,
  notesState,
  notesFilterState,
  pendingNewReportExportState,
  setNotesFilterState,
  setReportExportModalState,
  openReportExportModal,
}: Props) {
  return (
    <Reports
      projectId={projectId}
      selectedFeature={feature}
      featureCollection={featureCollection}
      propertyParts={propertyParts}
      overlayFeatureCollections={overlayFeatureCollections}
      overlaySettings={overlaySettings}
      organization={organization}
      setReportExportFilterState={setNotesFilterState}
      setReportExportModalState={setReportExportModalState}
      openReportExportModal={openReportExportModal}
      isMultiLocationProperty={isMultiLocationProperty}
      notesState={notesState}
      notesFilterState={notesFilterState}
      reportExportState={pendingNewReportExportState}
    />
  );
}
